import React from 'react';
import SvgIcon from './SvgIcon';

const Incident = props => (
    <SvgIcon {...props}>
        <g id="Incident" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M2,12 C3.1045695,12 4,12.8954305 4,14 C4,15.1045695 3.1045695,16 2,16 C0.8954305,16 0,15.1045695 0,14 C0,12.8954305 0.8954305,12 2,12 Z M15,12 C15.6,12 16,12.4 16,13 L16,13 L16,15 C16,15.6 15.6,16 15,16 L15,16 L7,16 C6.4,16 6,15.6 6,15 L6,15 L6,13 C6,12.4 6.4,12 7,12 L7,12 Z M2,6 C3.1045695,6 4,6.8954305 4,8 C4,9.1045695 3.1045695,10 2,10 C0.8954305,10 0,9.1045695 0,8 C0,6.8954305 0.8954305,6 2,6 Z M15,6 C15.6,6 16,6.4 16,7 L16,7 L16,9 C16,9.6 15.6,10 15,10 L15,10 L7,10 C6.4,10 6,9.6 6,9 L6,9 L6,7 C6,6.4 6.4,6 7,6 L7,6 Z M2,0 C3.1045695,0 4,0.8954305 4,2 C4,3.1045695 3.1045695,4 2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 Z M15,0 C15.6,0 16,0.4 16,1 L16,1 L16,3 C16,3.6 15.6,4 15,4 L15,4 L7,4 C6.4,4 6,3.6 6,3 L6,3 L6,1 C6,0.4 6.4,0 7,0 L7,0 Z"
                id="Combined-Shape"
                fill="#FFFFFF"
                fillRule="nonzero"
            ></path>
        </g>
    </SvgIcon>
);

Incident.displayName = 'IncidentIcon';

export default Incident;
